import { render, staticRenderFns } from "./RPRO.vue?vue&type=template&id=fa89c012&scoped=true"
import script from "./RPRO.vue?vue&type=script&lang=js"
export * from "./RPRO.vue?vue&type=script&lang=js"
import style0 from "./RPRO.vue?vue&type=style&index=0&id=fa89c012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa89c012",
  null
  
)

export default component.exports